export default "__VITE_ASSET__CEEgLXN5__"